// 获取C端设置佣金比例
export const getBdClientCommissionRate = function (params) {
  return this.$http('get', 'mall/clientCommissionRate/getBdClientCommissionRate', params);
}

// 修改C端设置佣金比例
export const modifyBdClientCommissionRate = function (params) {
  return this.$http('post', 'mall/clientCommissionRate/modifyBdClientCommissionRate', params);
}

// 查询当前渠道折扣点
export const getBdDownStreamCommissionRate = function (params) {
  return this.$http('get', 'mall/bdDownStreamCommissionRate/getCommissionRate', params);
}

// 保存渠道折扣点
export const saveBdDownStreamCommissionRate = function (data) {
  return this.$http('post', 'mall/bdDownStreamCommissionRate/saveCommissionRate', data);
}
